module.exports = __webpack_public_path__ + "static/img/sw-logo.3f5e618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sw-logo.png
// module id = s+7v
// module chunks = 0